export default __webpack_public_path__ + "images/TiemposHeadline-Bold.font.b1efeda9921dcf75c8e3126cc88fb4c3.svg";